import { CodeListItem, ImportMapping, ImportMappingType, ModifiedCodeMappings } from '../types-store';

const modifiedImportCodes = (importMapping: ImportMapping) =>
  (!!importMapping.externalValue && importMapping.externalValue !== importMapping.existingExternalValue)
  && (importMapping.type === ImportMappingType.Updated
    || importMapping.type === ImportMappingType.NewUpdated
    || importMapping.type === ImportMappingType.Deleted);

export const getNumberOfModifiedImportCodes = (modifiedItems: ModifiedCodeMappings[] = []) =>
  modifiedItems
    .reduce((total, item) => total + item.importMapping
      .filter(t => modifiedImportCodes(t)).length, 0);

export const isImportCodeModified = (id: number, codetableId: number, modifiedItems: ModifiedCodeMappings[] = []) =>
  modifiedItems
    .filter(item => item.id === id && item.codetable === codetableId)
    .reduce((total, item) => item.importMapping
      .some(t => modifiedImportCodes(t)), false);

export const initializeImportMappings =
  (importNumber: number, currentCode: CodeListItem, modifiedItems: ModifiedCodeMappings[], isError: boolean = false) => ({
    ...currentCode,
    importMapping: modifiedItems.map(item => {
      return {
        ...item,
        importMapping: item.importMapping
          .filter(value => value.type !== ImportMappingType.Deleted)
          .map(value => value.type !== ImportMappingType.Init && value.type !== ImportMappingType.New
            ? {
              importNumber: importNumber ?? value.importNumber,
              externalValue: value.externalValue,
              existingExternalValue: isError ? value.existingExternalValue : value.externalValue,
              type: ImportMappingType.Init
            } : value
          )
      };
    })?.[0]?.importMapping
  });

export const removeAllEnters = (value: string) => value.replace(/(\r\n|\n|\r)/gm, '');

export const removeImportMapping = (index: number, importMapping: ImportMapping[]) =>
  Object.keys(importMapping)
    .map(item => parseInt(item, 10))
    .filter(t => t !== index)
    .map(i => importMapping[i]);

export const setModifyImportMappingType = (modifiedData: ImportMapping) => {
  const newUpdatedValue = modifiedData.existingExternalValue === '' && !!modifiedData.externalValue;
  const newNotValidUpdated = modifiedData.importNumber === undefined && modifiedData.type === ImportMappingType.Updated;
  const hasError = newNotValidUpdated && !modifiedData.externalValue && modifiedData.existingExternalValue === undefined;

  return !!(hasError && ImportMappingType.NewUpdated)
    ? ImportMappingType.Error
    : newUpdatedValue || newNotValidUpdated
      ? ImportMappingType.NewUpdated
      : (modifiedData.externalValue === '' ? ImportMappingType.Deleted : modifiedData.type);
};
